const SCOPE = "profile";
const ERROR_MAP = {
  popup_closed_by_user: "Popup has been closed.",
  popup_blocked_by_browser: "Popup blocked by browser.",
};

const start = async (gapi, config, cbFn) => {
  try {
    await gapi.client.init({
      apiKey: config.apiKey,
      clientId: config.clientId,
      scope: SCOPE,
    });
    const GoogleAuth = gapi.auth2.getAuthInstance();
    GoogleAuth.signIn().then(
      user => {
        cbFn(null, user);
      },
      err => {
        cbFn(new Error(ERROR_MAP[err.error] || err.error));
      }
    );
    GoogleAuth.isSignedIn.listen(isSignedIn => {
      if (isSignedIn) {
        cbFn(null, GoogleAuth.currentUser.get());
      }
    });
  } catch (error) {
    console.error(error);
    cbFn(new Error(ERROR_MAP[error.error] || error.details || error.message));
  }
};

export const loginWithGoogle = async config => {
  let data = null;
  let error = null;
  const gapi = await getGapi();
  const callbackFn = (err, user) => {
    if (err) return (error = err);
    const authRes = user.getAuthResponse();
    data = {
      idToken: authRes.id_token,
    };
  };

  gapi.load("client:auth2", start.bind(null, gapi, config, callbackFn));
  return new Promise((resolve, reject) => {
    let id = setInterval(() => {
      if (data || error) {
        clearInterval(id);
        error && reject(error);
        data && resolve(data);
      }
    }, 100);
  });
};

const getGapi = resolveFn => {
  return new Promise(async resolve => {
    resolveFn = resolveFn || resolve;
    if (window.gapi) {
      return resolveFn(window.gapi);
    }
    setTimeout(() => {
      getGapi(resolve);
    }, 100);
  });
};
